module.exports = __webpack_public_path__ + "static/img/kca-innovation.b6d1a67.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kca-innovation.jpg
// module id = 26vY
// module chunks = 0